
import { defineComponent, ref, onMounted } from "vue";
import { Actions } from "@/store/enums/StoreEnums";
import { useStore } from "vuex";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";

export default defineComponent({
  setup() {
    onMounted(() => {
      setCurrentPageBreadcrumbs("资产法盈亏排行列表", [
        "资产法盈亏排行;asset_loser_items",
      ]);
    });

    const store = useStore();
    const tableData = ref([]);

    const formData = ref({
      nickname: "",
      mobile: "",
    });

    const page = ref({
      currentPage: 1,
      pageSize: 10,
      totalResult: 0,
    });

    let date = new Date();
    let from = new Date(
      date.getFullYear(),
      date.getMonth(),
      date.getDate(),
      0,
      0,
      0
    );
    let to = new Date(
      date.getFullYear(),
      date.getMonth(),
      date.getDate(),
      23,
      59,
      59
    );

    const duration = ref([from, to]);

    const query = () => {
      let params = {
        ...formData.value,
        from: `${duration.value[0].toLocaleDateString()} ${duration.value[0].getHours()}:${duration.value[0].getMinutes()}:${duration.value[0].getSeconds()}`,
        to: `${duration.value[1].toLocaleDateString()} ${duration.value[1].getHours()}:${duration.value[1].getMinutes()}:${duration.value[1].getSeconds()}`,
      };

      store
        .dispatch(Actions.GET_ASSET_LOSER_ITEMS, { ...params, ...page.value })
        .then(() => {
          tableData.value = store.getters.currentAssetLoserItems;
          page.value.totalResult = store.getters.currentAssetLoserItemCount;
        })
        .catch(() => {
          // silently ignore
        });
    };

    query();

    const submitEvent = () => {
      query();
    };

    const onPageChange = (e) => {
      page.value.currentPage = e.currentPage;
      query();
    };

    const onReset = () => {
      formData.value = {
        nickname: "",
        mobile: "",
      };
    };

    const formatDate = (date) => {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear(),
        hour = "" + d.getHours(),
        minute = "" + d.getMinutes(),
        second = "" + d.getSeconds();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;
      if (hour.length < 2) hour = "0" + hour;
      if (minute.length < 2) minute = "0" + minute;
      if (second.length < 2) second = "0" + second;

      return [year, month, day, hour, minute, second].join("");
    };

    const onDownload = () => {
      let params = {
        ...formData.value,
        from: `${duration.value[0].toLocaleDateString()} ${duration.value[0].getHours()}:${duration.value[0].getMinutes()}:${duration.value[0].getSeconds()}`,
        to: `${duration.value[1].toLocaleDateString()} ${duration.value[1].getHours()}:${duration.value[1].getMinutes()}:${duration.value[1].getSeconds()}`,
      };

      store
        .dispatch(Actions.GET_DOWNLOAD_ASSET_LOSER_ITEMS, params)
        .then(() => {
          const blob = new Blob(
            [store.getters.currentDownloadAssetLoserItems],
            { type: "application/xlsx" }
          );
          const link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          link.download = `asset_loser_items_${formatDate(
            Date().toString()
          )}.xlsx`;
          link.click();
          URL.revokeObjectURL(link.href);
        })
        .catch(() => {
          // silently ignore
        });
    };

    return {
      tableData,
      formData,
      submitEvent,
      page,
      onPageChange,
      onReset,
      duration,
      onDownload,
    };
  },
});
